import "../models/response.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Collections ??= {};

AssessmentBuilder.Collections.Responses = class Responses extends Backbone.Collection {};
AssessmentBuilder.Collections.Responses.prototype.model = AssessmentBuilder.Models.Response;
AssessmentBuilder.Collections.Responses.prototype.comparator = "position";
